export default "__VITE_ASSET__DbKUJdWl__"